import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class PlanSaleBillingsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/plan_sale_billings", { params: toSnakeCase(params) });
  }

  fetchInvoice(planSaleBillingId) {
    return securedAxiosInstance.get(`/plan_sale_billings/${planSaleBillingId}/invoice`);
  }
}

export default new PlanSaleBillingsService();
